<template>
	<div id="book-time-main">
		<div class="bg-white">
			<div
				class="padding-top-xs-1 padding-bottom-xs-1"
				v-if="!activityGroups.bookable.length"
			>
				<img
					class="loading-spinner"
					src="/wp-content/themes/nordiskakliniken/dist/images/loading-spinner.svg"
				/>
			</div>

			<BookingModuleSearchActivity
				v-if="activityGroups.bookable.length"
			/>

			<div
				class="container hidden-xs hidden-sm"
				:class="{ 'nk-force-disable': loading.doingBooking }"
			>
				<div class="row">
					<!-- Treatment -->
					<!--<div class="col-xs-12 padding-top-xs-2 padding-bottom-xs-2">-->
					<div class="col-xs-12">
						<div class="padding-top-xs-0 padding-bottom-xs-0">
							<div class="fade-on-hover---">
								<span
									v-for="activityGroup in activityGroups.bookable"
									:key="activityGroup.activity_group_id"
								>
									<a
										v-if="
											activityGroups.selected !=
											activityGroup
										"
										href="#"
										class="
											nk-button nk-button-margin
											link-plus-right
										"
										@click.prevent="
											setActivityGroup(activityGroup)
										"
										v-bind:class="{
											'link-close-right':
												activityGroups.selected ==
												activityGroup,
											'nk-button-inactive':
												activityGroups.selected !=
													activityGroup &&
												activityGroups.selected,
											'nk-button-light-nude':
												!activityGroups.selected ||
												activityGroups.selected ==
													activityGroup,
										}"
										>{{
											activityGroup.activity_group_name
										}}</a
									>
									<a
										v-if="
											activityGroups.selected ==
												activityGroup &&
											!activities.selected
										"
										href="#"
										class="
											nk-button nk-button-margin
											link-plus-right
										"
										@click.prevent="
											setActivityGroup(activityGroup);
											activities.selected = false;
										"
										v-bind:class="{
											'link-close-right':
												activityGroups.selected ==
												activityGroup,
											'nk-button-inactive':
												activityGroups.selected !=
													activityGroup &&
												activityGroups.selected,
											'nk-button-light-nude':
												activityGroups.selected ==
												activityGroup,
										}"
										>{{
											activityGroup.activity_group_name
										}}</a
									>
									<a
										v-if="
											activityGroups.selected ==
												activityGroup &&
											activities.selected
										"
										href="#"
										class="
											nk-button nk-button-margin
											link-close-right
											nk-button-light-nude
										"
										@click.prevent="
											activities.selected = false
										"
										>{{
											activities.selected.activity_name
										}}</a
									>
								</span>
							</div>
						</div>
					</div>

					<!-- Activities -->
					<div
						v-if="activityGroups.selected && !activities.selected"
						class="col-xs-12"
					>
						<div class="hidden-xs hidden-sm">
							<ul
								class="
									nk-list
									nk-list-two-columns-md
									nk-treatments-list
									padding-top-xs-2
								"
							>
								<li v-for="activity in activities.active">
									<a
										href="#"
										@click.prevent="setActivity(activity)"
										class="force-icon-right"
										v-bind:class="{
											'link-plus-right':
												activities.selected == activity,
											'text-gray':
												activities.selected !=
													activity &&
												activities.selected,
										}"
										><span
											v-if="activityIsCampaign(activity)"
											class="campaign-offer-icon"
											><img
												src="/wp-content/themes/nordiskakliniken/dist/images/star-solid.svg"
										/></span>
										{{ activity.activity_name }}</a
									>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<BookingMobileButtons />
		</div>

		<div
			class="book-time-dates padding-bottom-xs-2 padding-bottom-md-4"
			:class="{
				'book-time-inactive': !activities.selected || ui.loading.times,
				'hidden-xs': !selectedSlot,
				'hidden-sm': !selectedSlot,
			}"
			id="book-time-dates"
		>
			<div class="container">
				<div class="hidden-xs hidden-sm">
					<BookingCalendarDesktop v-if="isActivityBookable(activities.selected.activity_id)"/>
					<div class="row" v-if="!isActivityBookable(activities.selected.activity_id)">
						<div class="col-xs-12 col-lg-6">
							<div
								class="alert alert-nk"
							>
								<div class="message-wrapper" v-html="unbookableTreatmentMessage"></div>
							</div>
						</div>
					</div>
					<div class="row">
						<PatientForm />
					</div>
				</div>
			</div>
		</div>

		<BookingMobileTimeSlots />
		<BookingMobileModalPatientForm />
		<BookingConfirmedModal />
		<BookingErrorModal />
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import BookingMobileButtons from "./BookingMobileButtons.vue";
import BookingMobileTimeSlots from "./BookingMobileTimeSlots.vue";
import BookingMobileModalPatientForm from "./BookingMobileModalPatientForm.vue";
import PatientForm from "./PatientForm.vue";
import BookingConfirmedModal from "./BookingConfirmedModal.vue";
import BookingErrorModal from "./BookingErrorModal.vue";
import BookingCalendarDesktop from "./BookingCalendarDesktop.vue";
import BookingModuleSearchActivity from "./BookingModuleSearchActivity.vue";

export default {
	components: {
		BookingMobileButtons,
		BookingMobileTimeSlots,
		BookingMobileModalPatientForm,
		PatientForm,
		BookingConfirmedModal,
		BookingErrorModal,
		BookingCalendarDesktop,
		BookingModuleSearchActivity,
	},
	computed: {
		...mapState([
			"activityGroups",
			"activities",
			"providers",
			"selectedSlot",
			"dates",
			"ui",
			"booking",
			"patient",
			'unbookableTreatments',
			'unbookableTreatmentMessage'
		]),
		...mapGetters([
			"dateIsInThePast",
			"activityIsCampaign",
			"formatProviderName",
			"selectedSlotFormated",
			"formIsValid",
			"loading",
			"isActivityBookable"
		]),
	},
	methods: {
		...mapActions([
			"setActivityGroup",
			"setActivity",
			"setupActiveDates",
			"setSelectedSlot",
			"setProvider",
			"getRealWeekday",
			"setModalState",
			"handleSwipe",
			"shouldDeselectTimeslot",
		]),
	},
	created() {
		this.$store.dispatch("init", {
			vueInstance: this,
		});
	},

	watch: {
		/* Watch for changes to the availableTimes object. This is necessary to make the slick slider work as intended */
		availableTimes(newTimes) {
			if (!this.$refs.slick) {
				return;
			}

			let currIndex = this.$refs.slick.currentSlide();
			this.$refs.slick.destroy();
			this.$nextTick(() => {
				this.$refs.slick.create();
				this.$refs.slick.goTo(currIndex, true);
			});
		},
	},
};
</script>